export default __webpack_public_path__ + "static/media/event_randaja.6b703205.png";